<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{data.sysText.contactLeaveAdmin_title}}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <ng-container>
    <p class="body2 bottom-margin">{{ data.sysText.sendToContact }} <span class="semibold">{{ data.admin.description }}</span></p>
    <form [formGroup]="form">
      <app-input-field
        [group]="form"
        [control]="title"
        [icon]="'mail'"
        [label]="data.sysText.title">
      </app-input-field>

      <app-text-area
        [control]="message"
        [label]="data.sysText.message"
        [icon]="'edit_note'">
      </app-text-area>

      <input hidden type="file" #imgFileInput (change)="handleFileInput($event.target.files)" autocomplete="off"/>
      <div class="file-input-field">
        <mat-icon class="input-icon">attach_file</mat-icon>
        <button
          #uploadButton
          type="button"
          mat-stroked-button
          color="accent"
          (click)="imgFileInput.click()"
          class="button">
          <mat-icon>upload</mat-icon>
          <span>{{data.sysText.upload | capitalizefirst}}</span>
        </button>
        <mat-error class="body2 upload-error" aria-live="polite">{{ attachment.errors?.msError}}</mat-error>
      </div>
      @if (fileToUpload) {
        <div class="pad">
          <div class="flex-horiz bot-space">
            <mat-icon class="fill4-dk">check</mat-icon>
            <div>
              <span class="body2 side-space grey3">{{ fileToUpload?.name }}</span>
            </div>
            <button type="button" class="button-reset" [attr.aria-label]="data.sysText.removeFile_ariaLabel" (click)="clearFile()">
              <mat-icon class="black-inactive small pointer">clear</mat-icon>
            </button>
          </div>
        </div>
      }
    </form>
  </ng-container>

</mat-dialog-content>
<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{ data.sysText.submit }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>
